import { axiosInstance } from "@/api/axiosInstance";
import {
  ApiKeysApi,
  ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest,
  ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new ApiKeysApi(undefined, BASE_API, axiosInstance);

export const generateApiKey = async (
  payload: ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest
) => {
  return api.usersViewsNinjaApiKeysGenerateApiKeys.bind(api)(payload);
};

export const getApiKey = async (
  payload: ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest
) => {
  return api.usersViewsNinjaApiKeysGetPublicKey.bind(api)(payload);
};
